import { WorkflowLayout, WorkflowLayoutProps } from "@portal/components/layout/WorkflowLayout";
import { AgentUserMenu } from "../settings/AgentUserMenu";
import { AgentHeaderActionButtons } from "../shared/AgentHeaderActionButtons";

export const AgentWorkflowLayout = (
	props: Omit<WorkflowLayoutProps, "userMenu" | "headerActionButtons"> & {
		hideActionButtons?: boolean;
	},
) => (
	<WorkflowLayout
		userMenu={<AgentUserMenu />}
		headerActionButtons={<AgentHeaderActionButtons hideActionButtons={props.hideActionButtons} />}
		{...props}
	/>
);
